import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { Grid, Dialog, DialogTitle, Typography, DialogContent, DialogActions, Button } from "@material-ui/core";
import { Autocomplete } from "@totalsoft/rocket-webapp-components-deprecated";
import { onTextBoxChange } from "utils/propertyChangeAdapters";
import { useTranslation } from "react-i18next";
import { get, set } from "@totalsoft/react-state-lens";
import { CustomTextField } from "@totalsoft/rocket-webapp-components-deprecated";
import { emptyString } from "constants/defaultValues";
import { addToast } from "components/notifications";
import { noWhitespaceOrSymbols } from "utils/simple-validations/validations";
import { useValidation } from "@totalsoft/pure-validations-react";
import { getErrors, isValid } from "@totalsoft/pure-validations-react";
import { stopOnFirstFailure } from "@totalsoft/pure-validations";
import * as V from "@totalsoft/pure-validations";

const options = ["Schedule", "ScheduleColumn", "Service"];
export const validator = V.shape({
  key: [V.required, noWhitespaceOrSymbols] |> stopOnFirstFailure,
  value: V.required,
});

const TranslationAdd = (props) => {
  const { stringTranslationLens, open, onCloseModal, setIsElementAdded, stringTranslationsLens } = props;
  const [prefixedKey, setPrefixedKey] = useState(options[0]);
  const { t } = useTranslation();
  const [validation, validate] = useValidation(validator);
  const translation = stringTranslationLens |> get;

  const handleSelectChange = useCallback(
    (value) => {
      setPrefixedKey(value);
      (stringTranslationLens.key |> set)(emptyString);
      (stringTranslationLens.value |> set)(emptyString);
    },
    [stringTranslationLens.key, stringTranslationLens.value]
  );

  const handleAdd = useCallback(async () => {
    if (!validate(translation)) return;

    const key = `Server.${prefixedKey}.${translation.key}`;
    const keyExists = (stringTranslationsLens.strings |> get).some((lens) => lens.key === key);

    if (keyExists) {
      addToast(t("Settings.Translations.TranslationExistsMessage"), "error");
      return;
    }
    (stringTranslationLens.defaultValue |> set)(translation.value);
    (stringTranslationLens.key |> set)(key);

    setIsElementAdded(true);
    onCloseModal();
  }, [
    onCloseModal,
    prefixedKey,
    setIsElementAdded,
    stringTranslationLens.defaultValue,
    stringTranslationLens.key,
    stringTranslationsLens,
    t,
    translation,
    validate,
  ]);

  const handleModalClose = useCallback(() => {
    const modifiedTranslations = (stringTranslationsLens.strings |> get).slice(0, -1);
    (stringTranslationsLens.strings |> set)(modifiedTranslations);
    onCloseModal();
  }, [onCloseModal, stringTranslationsLens]);
  return (
    <Dialog maxWidth={"sm"} fullWidth open={open} onClose={handleModalClose}>
      <DialogTitle>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography>{t("Settings.Translations.ScheduleTranslations")}</Typography>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} alignContent="center" direction="row">
          <Grid item xs={12}>
            <Autocomplete
              required
              fullWidth
              label={t("Settings.Translations.Type")}
              options={options}
              value={prefixedKey}
              onChange={handleSelectChange}
              disableClearable={true}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomTextField
              required
              fullWidth
              label={t("Settings.Translations.Key")}
              value={translation.key || emptyString}
              onChange={stringTranslationLens.key |> set |> onTextBoxChange}
              error={!isValid(validation.key)}
              helperText={getErrors(validation.key)}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomTextField
              required
              fullWidth
              label={t("Settings.Translations.Value")}
              value={translation.value || emptyString}
              onChange={stringTranslationLens.value |> set |> onTextBoxChange}
              error={!isValid(validation.value)}
              helperText={getErrors(validation.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAdd} color="primary" variant="contained">
          {t("Settings.Translations.Done")}
        </Button>
        <Button onClick={handleModalClose} color="secondary">
          {t("Cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

TranslationAdd.propTypes = {
  stringTranslationLens: PropTypes.object.isRequired,
  stringTranslationsLens: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  setIsElementAdded: PropTypes.func.isRequired,
};

export default TranslationAdd;
